// Tab taxonomy for the admin account detail page (PHO-14367).
// Shared between the route's search-param schema and the detail
// component so deep links stay validated in one place.
export const ACCOUNT_DETAIL_TABS = [
    'home',
    'overview',
    'health',
    'agent',
    'activity',
    'meetings',
    'tickets',
    'onboarding',
] as const;

export type AccountDetailTab = (typeof ACCOUNT_DETAIL_TABS)[number];

export const DEFAULT_ACCOUNT_DETAIL_TAB: AccountDetailTab = 'home';

// Pre-tab deep links used #section anchors; map them onto the tab
// that now owns each section so old links keep landing correctly.
export const LEGACY_SECTION_HASH_TABS: Record<string, AccountDetailTab> = {
    activity: 'activity',
    health: 'health',
    notes: 'overview',
    onboarding: 'onboarding',
    people: 'overview',
};

export function isAccountDetailTab(value: unknown): value is AccountDetailTab {
    return (
        typeof value === 'string' &&
        (ACCOUNT_DETAIL_TABS as ReadonlyArray<string>).includes(value)
    );
}
